const  serverAPI_ = window.location.href.indexOf('localhost') > -1 ?  "http://bs-ctg-app-dev.win.ftc.ru:4443" : '';

const  serverAPI = window.location.href.indexOf('localhost') > -1 ?  "https://bs-ctg-app-dev.win.ftc.ru" : '';
//console.log(serverAPI)
export default { serverAPI:serverAPI_}